import {useEffect} from 'react';
import {withRouter} from "components/router/withRouter";
import {BATCH_ACTIONS, LOADING_STATUS} from "utils/constants.js";
import {confirmBatch, loadTasks, unbundleBatch} from "components/mytasks/myTasks.action.js";
import {useDispatch, useSelector} from "react-redux";
import * as reduxSelectors from "components/store/application.reducers.js";
import * as Api from "utils/api/api";
import _ from "lodash";
import {tasksWithPaymentData} from "components/mytasks/action/handleBatch.action";
import {PATH_TO_MY_TASKS} from "components/router/paths";
import {handleError} from "utils/errorHandle.function";
import {useNavigate} from "react-router-dom";
import {approveMultipleTasks} from "components/mytasks/action/approveMultipleTasks.action";

function NewPreApproval(props: any) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tasksWithPayment = useSelector(reduxSelectors.getTasksWithPayment);
    const tasksLoadingStatus = useSelector(reduxSelectors.getLoadingStatus);

    useEffect(() => {
        dispatch(loadTasks());
    }, []);


    useEffect(() => {
        if (tasksLoadingStatus === LOADING_STATUS.DONE)
            handleApprovalProcess().catch((error) => {
                handleError(error);
            });
    }, [tasksLoadingStatus]);

    const handleApprovalProcess = async () => {
        let params = new URLSearchParams(props.location.search);
        let batchId = params.get('batchId');
        let batchAction = params.get('batchAction');
        let secret = params.get('secret');
        try {
            const response = await Api.getActiveBatches();
            if (batchAction === BATCH_ACTIONS.CANCEL && response?.version) {
                dispatch(unbundleBatch(batchId, response.version));
                navigate(PATH_TO_MY_TASKS);
            } else if (batchAction === BATCH_ACTIONS.CONFIRM && secret) {
                if (response && response.documents) {
                    let taskIds: any[] = [];
                    response.documents.forEach((doc: any) => {
                        let found = _.find(tasksWithPayment, (task) => task.id === doc.taskId);
                        if (found) taskIds.push(found.key);
                    });
                    dispatch(confirmBatch(batchId, response.version, secret));
                    const tasksData = dispatch(tasksWithPaymentData(taskIds));
                    dispatch(approveMultipleTasks(tasksData, undefined, undefined, undefined, true, navigate));
                    navigate(PATH_TO_MY_TASKS);
                }
            } else
                navigate(PATH_TO_MY_TASKS);


        } catch (error) {
            handleError(error);
        }

    }

    return (
        <div/>
    )
}

export default withRouter(NewPreApproval);